module.exports = __webpack_public_path__ + "static/media/An underwater city filled with bioluminescent creatures and glowing coral reefs.1cd82bf2.jpeg";